import { render } from "./CourseHealth.vue?vue&type=template&id=74051673&scoped=true"
import script from "./CourseHealth.vue?vue&type=script&lang=js"
export * from "./CourseHealth.vue?vue&type=script&lang=js"

import "./CourseHealth.vue?vue&type=style&index=0&id=74051673&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74051673"]])

export default __exports__